import styled from 'styled-components';
import Link from '../Link';

export const AdvertList = styled.div`
	margin: 24px 0 32px;
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const AdvertLinkTitle = styled.span`
	display: block;
	padding: 11px 16px;
	border-radius: 4px;
	background-color: ${({ theme }) => theme.grayColor};
	color: #000;
`;

export const AdvertLinkPrice = styled.span`
	padding: 8px 12px;
	margin: 0 auto;
	color: ${({ theme }) => theme.primaryColor};
	text-decoration: underline;

	@media (max-width: 480px) {
		margin: 0;
	}
`;

export const AdvertLink = styled(Link)`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
	grid-gap: 8px;
	font-weight: 500;
	text-decoration: none;

	&:hover {
		${AdvertLinkTitle} {
			background-color: ${({ theme }) => theme.middleGrayColor};
		}

		${AdvertLinkPrice} {
			color: ${({ theme }) => theme.primaryHover};
		}
	}
`;
